import { queryOptions } from "@tanstack/react-query";

import { listUsers } from "@/features/users/api";

/**
 * Every user in the tenant, as one list.
 *
 * `GET /api/v1/admin/users` has no cursor — an admin's user list is tens
 * of people, not thousands, so a plain query rather than the keyset
 * pagination every record and submission list uses.
 */
export function usersQuery() {
  return queryOptions({
    queryKey: ["admin-users"],
    queryFn: listUsers,
  });
}
